module.exports = __webpack_public_path__ + "static/media/app-we-icon.ea8b1e1a.svg";